module.exports = __webpack_public_path__ + "static/media/logo-bg.24afd279.png";